/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectCategoryCommand } from '../../models/delete-project-category-command';
import { DeleteProjectCategoryCommandResult } from '../../models/delete-project-category-command-result';

export interface ApiProjectCategoriesDeleteProjectCategoryDelete$Plain$Params {
  
    /**
     * The details of the Project Category to delete.
     */
    body?: DeleteProjectCategoryCommand
}

export function apiProjectCategoriesDeleteProjectCategoryDelete$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectCategoriesDeleteProjectCategoryDelete$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectCategoryCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectCategoriesDeleteProjectCategoryDelete$Plain.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectCategoryCommandResult>;
    })
  );
}

apiProjectCategoriesDeleteProjectCategoryDelete$Plain.PATH = '/api/ProjectCategories/DeleteProjectCategory';
